import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const ClockOutline = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M18 11.4231V18.8221L22.9327 22.9327M28.6875 18C28.6875 23.9025 23.9025 28.6875 18 28.6875C12.0975 28.6875 7.3125 23.9025 7.3125 18C7.3125 12.0975 12.0975 7.3125 18 7.3125C23.9025 7.3125 28.6875 12.0975 28.6875 18Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper strokeWidth={1} {...props} variant="outline" viewBox="0 0 36 36">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { ClockOutline };